import { useTranslation } from "react-i18next";
import { useContext, useEffect } from "react";
import { MemberContext } from "../../../context/memberContext";
import SideBlock from "../../common/SideBlock";
import UserAvatar from "../../common/UserAvatar";
import Username from "../../common/Username";

const SidenavSection = () => {
	const { t } = useTranslation();

	const { followers, followersLoading, hasMoreFollowers, loadMoreFollowers, fetchUserFollowers, trophies, fetchUserTrophies } =
		useContext(MemberContext);

	useEffect(() => {
		fetchUserFollowers(true);
		fetchUserTrophies();
	}, [fetchUserFollowers, fetchUserTrophies]);

	return (
		<div className="hidden lg:block">
			{followers && followers.length > 0 && (
				<SideBlock title={t("followers")}>
					<ul className="max-h-[250px] overflow-y-scroll">
						{followers.map((follower, index) => (
							<li key={index} className="flex items-center mb-4">
								<div className="w-[32px] h-[32px] flex-grow-0 flex-shrink-0 mr-2">
									<UserAvatar user={follower} />
								</div>

								<h4 className="text-sm min-w-0 flex-1">
									<Username user={follower} />
								</h4>
							</li>
						))}
					</ul>

					{hasMoreFollowers && (
						<div className="text-center mt-4">
							<button
								onClick={loadMoreFollowers}
								className="w-full px-2 py-1 bg-primary text-sm font-semibold text-white rounded transition hover:bg-red-900"
							>
								{followersLoading ? "Loading..." : "Load More"}
							</button>
						</div>
					)}
				</SideBlock>
			)}

			{trophies && trophies.length > 0 && (
				<SideBlock title={t("trophies")}>
					<ul>
						{trophies.map((trophy, index) => (
							<li key={index} className="flex mb-4">
								<div className="w-[32px] text-center text-white text-xl font-semibold flex-grow-0 flex-shrink-0 mr-2">
									{trophy.Trophy.trophy_points}
								</div>

								<div className="text-white min-w-0 flex-1">
									<p className="text-sm mb-2">{trophy.Trophy.title}</p>
									<p className="text-xs text-gray-400">{trophy.Trophy.description}</p>
								</div>
							</li>
						))}
					</ul>
				</SideBlock>
			)}
		</div>
	);
};

export default SidenavSection;
